import { render, staticRenderFns } from "./kyc_step_three.vue?vue&type=template&id=57ae1964&scoped=true"
import script from "./kyc_step_three.vue?vue&type=script&lang=js"
export * from "./kyc_step_three.vue?vue&type=script&lang=js"
import style0 from "./kyc_step_three.vue?vue&type=style&index=0&id=57ae1964&prod&scoped=true&lang=css"
import style1 from "./kyc_step_three.vue?vue&type=style&index=1&id=57ae1964&prod&lang=css"
import style2 from "./kyc_step_three.vue?vue&type=style&index=2&id=57ae1964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ae1964",
  null
  
)

export default component.exports